import { useEffect, useState } from 'react';
import type { IUser } from '@/common/interfaces/user.interface';
import { ACCOUNT_TYPES, USER_STATUS } from '@/constants/Home';

export function useAccount(user: IUser) {
  const [userType, setUserType] = useState('');

  useEffect(() => {
    if (user?.accountType === ACCOUNT_TYPES.COLLEGIATE) {
      setUserType(ACCOUNT_TYPES.COLLEGIATE);
    } else if (user?.accountType === ACCOUNT_TYPES.CORPORATE) {
      setUserType(ACCOUNT_TYPES.CORPORATE);
    } else if (user?.accountType === ACCOUNT_TYPES.OTHER) {
      setUserType(ACCOUNT_TYPES.OTHER);
    } else {
      setUserType('');
    }
  }, [user]);

  return userType;
}

export function useUserDecisionMaker(user: IUser | null) {
  const [isDecisionMaker, setIsDecisionMaker] = useState(false);

  useEffect(() => {
    if (user && user.status === USER_STATUS.DM) {
      setIsDecisionMaker(true);
    } else {
      setIsDecisionMaker(false);
    }
  }, [user]);

  return isDecisionMaker;
}

/**
 * Hook used to configure feature flags.
 *
 * @param user - The logged in user.
 * @param feature - The feature flag to check.
 */
export function useFeatureFlag(user: IUser | null, feature: string) {
  const [isEnabled, setIsEnabled] = useState(() => !!user?.switches?.[feature]);

  useEffect(() => {
    if (user?.switches?.[feature]) {
      setIsEnabled(true);
    } else {
      setIsEnabled(false);
    }
  }, [feature, user]);

  return isEnabled;
}
export const useAccountName = (user: IUser) => {
  const userType = useAccount(user);
  const [accountName, setAccountName] = useState('');
  const [accountSchool, setAccountSchool] = useState('');

  useEffect(() => {
    if (userType === ACCOUNT_TYPES.CORPORATE) {
      setAccountName(user?.business ?? 'None');
    } else if (userType === ACCOUNT_TYPES.COLLEGIATE) {
      setAccountSchool(user?.school === 'Other' ? user?.custom_school_name : user?.school);
      setAccountName(user?.organization ?? '');
    } else if (userType === ACCOUNT_TYPES.OTHER) {
      setAccountName(user?.organization ?? '');
    } else {
      setAccountName(user?.school ?? user?.organization ?? 'None');
    }
  }, [user?.business, user?.custom_school_name, user?.organization, user?.school, userType]);

  return { accountName, accountSchool };
};
